const authonIden = () =>
    import('@/module/index/pages/userCenter/authonIden.vue')

export default {
  path: '/authonIden',
  component: authonIden,
  //   redirect: '/userCenter/center/first',
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: false
  }
}



// WEBPACK FOOTER //
// ./src/publicResource/router/auth.js